import apiService from '../api/api.service';
import {IDeposit, IWithdrawal} from "../api/api.interfaces";
import {makeAutoObservable} from "mobx";

export class DepositWithdrawalStore {

    public deposits: IDeposit[] = [];
    public withdrawals: IWithdrawal[] = [];

    constructor() {
        makeAutoObservable(this);
    }

    async resetState() {
        this.deposits = []
        this.withdrawals = []
    }

    setDeposits(deposits: IDeposit[]) {
        this.deposits = deposits
    }

    setWithdrawals(withdrawals: IWithdrawal[]) {
        this.withdrawals = withdrawals
    }

    async fetchDeposits(userAddress: string) {
        try {
            this.setDeposits(await apiService.accountsDepositsGet({ user: userAddress}));
        } catch (error) {
            console.error('Failed to fetchDeposits:', error);
        }
    }
    async fetchWithdrawals(userAddress: string) {
        try {
            this.setWithdrawals(await apiService.accountsWithdrawalsGet({ user: userAddress}));
        } catch (error) {
            console.error('Failed to fetchWithdrawals:', error);
        }
    }
}

export const depositWithdrawalStore = new DepositWithdrawalStore();
